/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// fixedボタンの表示制御
window.addEventListener('scroll', function () {
    if (600 < window.scrollY) {
        document.getElementById('bottom_fixed_wrapper').style.transition = '.3s';
        document.getElementById('bottom_fixed_wrapper').style.visibility = 'visible';
        document.getElementById('bottom_fixed_wrapper').style.opacity = '1';
    } else {
        document.getElementById('bottom_fixed_wrapper').style.transition = 'unset';
        document.getElementById('bottom_fixed_wrapper').style.visibility = 'hidden';
        document.getElementById('bottom_fixed_wrapper').style.opacity = '0';
    }
});

$(function () {
    $('.ac-label').click(function (event) {
        $(this).next('div').slideToggle();
        $(this).find('.icon').toggleClass('open');
    });
});

$(function () {
    $('.ac-label2').click(function (event) {
        $(this).next('div').slideToggle();
        $(this).find('.icon2').toggleClass('open');
    });
});

$(function () {
    $('a[href^="#"]').click(function () {
        var speed = 500;
        var href = $(this).attr('href');
        var target = $(href == '#' || href == '' ? 'html' : href);
        var position = target.offset().top - 100; // ここで50pxを減算
        $('html, body').animate({ scrollTop: position }, speed, 'swing');
        return false;
    });
});

// コーディネートページ - スライド
jQuery(document).ready(function ($) {
    function initializeSwiper(selector) {
        var $swiperContainer = $(selector);
        var slidesCount = $swiperContainer.find('.swiper-slide').length;

        if (slidesCount <= 1) {
            $swiperContainer.find('.swiper-pagination, .swiper-button-next, .swiper-button-prev').hide();
        } else {
            new Swiper(selector, {
                loop: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                speed: 1000,
                // autoplay: {
                //     delay: 4000,
                //     disableOnInteraction: false,
                // },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 1,
            });
        }
    }

    initializeSwiper('#coordinate-recommend-main');
    initializeSwiper('#coordinate-recommend-gallery');
});

// コーディネートページ：ギャラリー部分展開ボタン
// jQuery(document).ready(function ($) {
//     function updateGallery($gallery, itemsPerPage) {
//         $gallery.find('.gallery-item').each(function (index) {
//             if (index < itemsPerPage) {
//                 $(this).show().removeClass('hidden-photo');
//             } else {
//                 $(this).hide().addClass('hidden-photo');
//             }
//         });
//     }

//     function checkWindowSize($gallery, itemsPerPagePC, itemsPerPageSP) {
//         if ($(window).width() <= 768) {
//             updateGallery($gallery, itemsPerPageSP);
//         } else {
//             updateGallery($gallery, itemsPerPagePC);
//         }
//     }

//     function debounce(func, wait) {
//         let timeout;
//         return function (...args) {
//             const context = this;
//             clearTimeout(timeout);
//             timeout = setTimeout(() => func.apply(context, args), wait);
//         };
//     }

//     $('.c-btn__gallery-text').each(function () {
//         var sectionId = $(this).data('section-id');
//         var $gallery = $('#coordinate-recommend-' + sectionId + ' .p-coordinate__recommend-gallery__list');
//         var $gradient = $('#gradient-' + sectionId);
//         var $moreBtn = $('#more-btn-' + sectionId);
//         var $listGradient = $('#coordinate-recommend-' + sectionId + ' .p-coordinate__recommend-gallery__list-gradient');
//         var itemsPerPagePC = 8;
//         var itemsPerPageSP = 6;
//         var totalImages = $gallery.find('.gallery-item').length;
//         var isExpanded = false;

//         function initialCheck() {
//             checkWindowSize($gallery, itemsPerPagePC, itemsPerPageSP);
//             if (totalImages <= itemsPerPagePC) {
//                 $gradient.hide();
//                 $moreBtn.hide();
//             } else {
//                 $gradient.show();
//                 $moreBtn.show();
//             }
//         }

//         initialCheck();

//         $(window).on(
//             'resize',
//             debounce(function () {
//                 checkWindowSize($gallery, itemsPerPagePC, itemsPerPageSP);
//             }, 200)
//         );

//         $(this).on('click', function (e) {
//             e.preventDefault();
//             if (!isExpanded) {
//                 $gallery.find('.hidden-photo').slideDown('slow').removeClass('hidden-photo');
//                 $(this).text('閉じる');
//                 $moreBtn.addClass('is-expanded');
//                 $gradient.fadeOut('slow');
//                 $listGradient.fadeOut('slow');
//             } else {
//                 var itemsPerPage = $(window).width() <= 768 ? itemsPerPageSP : itemsPerPagePC;
//                 $gallery
//                     .find('.gallery-item')
//                     .slice(itemsPerPage)
//                     .slideUp('slow', function () {
//                         $(this).addClass('hidden-photo');
//                     });
//                 $(this).text('もっと見る');
//                 $moreBtn.removeClass('is-expanded');
//                 $gradient.fadeIn('slow');
//                 $listGradient.fadeIn('slow');
//             }
//             isExpanded = !isExpanded;
//         });
//     });
// });

jQuery(document).ready(function ($) {
    var itemsPerPagePC = 8;
    var itemsPerPageSP = 6;
    var isExpanded = false;

    function updateGallery($gallery, itemsPerPage) {
        if (!isExpanded) {
            $gallery.find('.gallery-item').each(function (index) {
                if (index < itemsPerPage) {
                    $(this).show().removeClass('hidden-photo');
                } else {
                    $(this).hide().addClass('hidden-photo');
                }
            });
        }
    }

    function checkWindowSize($gallery) {
        var itemsPerPage = $(window).width() <= 768 ? itemsPerPageSP : itemsPerPagePC;
        updateGallery($gallery, itemsPerPage);
    }

    $('.c-btn__gallery-text').each(function () {
        var sectionId = $(this).data('section-id');
        var $gallery = $('#coordinate-recommend-' + sectionId + ' .p-coordinate__recommend-gallery__list');
        var $gradient = $('#gradient-' + sectionId);
        var $moreBtn = $('#more-btn-' + sectionId);
        var $listGradient = $('#coordinate-recommend-' + sectionId + ' .p-coordinate__recommend-gallery__list-gradient');

        // 初期表示の設定
        checkWindowSize($gallery);

        if ($gallery.find('.gallery-item').length <= itemsPerPagePC) {
            $gradient.hide();
            $moreBtn.hide();
        } else {
            $gradient.show();
            $moreBtn.show();
        }

        // リサイズイベント
        $(window).on('resize', function () {
            checkWindowSize($gallery);
        });

        // クリックイベント
        $(this).on('click', function (e) {
            e.preventDefault();
            $('.hidden-photo').slideToggle('slow');
            if (!isExpanded) {
                $(this).text('閉じる');
                $gradient.fadeOut('slow');
                $listGradient.fadeOut('slow');
                $moreBtn.addClass('is-expanded');
            } else {
                $(this).text('もっと見る');
                $gradient.fadeIn('slow');
                $listGradient.fadeIn('slow');
                $moreBtn.removeClass('is-expanded');
            }
            isExpanded = !isExpanded;
        });
    });
});
